const config = {
  AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL,
};

export default config;
